export default "__VITE_ASSET__CQq4OQOr__"